import { useMenu } from '@if/mui'
import AddIcon from '@mui/icons-material/Add'
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange'
import DateRangeIcon from '@mui/icons-material/DateRange'
import HistoryIcon from '@mui/icons-material/History'
import LocalAtmIcon from '@mui/icons-material/LocalAtm'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import TimerIcon from '@mui/icons-material/Timer'
import { Button, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Stack, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ELoanCalendarAction, useLoanCalendarAction } from '../LoanCalendarActionProvider'

const LoanCalendarTablePrimaryActions = () => {
  const { t } = useTranslation()
  const { dispatchAction } = useLoanCalendarAction()
  const [buttonProps, menuProps, handleMenuClose] = useMenu()

  const handleMenuAction = (action: ELoanCalendarAction) => () => {
    handleMenuClose()
    dispatchAction(action)
  }

  return (
    <Stack direction="row" display={{ xs: 'none', md: 'flex' }} gap={1}>
      <Button
        startIcon={<AddIcon />}
        color="primary"
        onClick={() => dispatchAction(ELoanCalendarAction.OpenAddPaymentDialog)}
      >
        {t('loan.payment.add')}
      </Button>
      <Button
        startIcon={<HistoryIcon />}
        onClick={() => dispatchAction(ELoanCalendarAction.OpenResetPaymentCalendarDialog)}
      >
        {t('loan.payment.reset')}
      </Button>
      <Tooltip title={t('loan.payment.otherGlobalActions')}>
        <IconButton {...buttonProps}>
          <MoreVertIcon />
        </IconButton>
      </Tooltip>
      <Menu {...menuProps}>
        <MenuItem>
          <ListItemIcon>
            <DateRangeIcon />
          </ListItemIcon>
          <ListItemText onClick={handleMenuAction(ELoanCalendarAction.OpenMoveCalendarDialog)}>
            {t('loan.payment.moveCalendar')}
          </ListItemText>
        </MenuItem>
        <MenuItem onClick={handleMenuAction(ELoanCalendarAction.OpenUpdatePaymentFrequencyDialog)}>
          <ListItemIcon>
            <TimerIcon />
          </ListItemIcon>
          <ListItemText>{t('loan.payment.editPaymentFrequency.title')}</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleMenuAction(ELoanCalendarAction.OpenChangeRegularPmtDialog)}>
          <ListItemIcon>
            <LocalAtmIcon />
          </ListItemIcon>
          <ListItemText>{t('loan.payment.editRegularPayment')}</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleMenuAction(ELoanCalendarAction.OpenAddRecurringPaymentsDialog)}>
          <ListItemIcon>
            <CurrencyExchangeIcon />
          </ListItemIcon>
          <ListItemText>{t('loan.payment.addRecurringPayments.title')}</ListItemText>
        </MenuItem>
      </Menu>
    </Stack>
  )
}

export default LoanCalendarTablePrimaryActions
